import React, { FC, ReactNode } from "react";

interface FormInputLayoutProps {
  label: string;
  name: string;
  helpElement?: ReactNode;
  fieldElement: ReactNode;
}

export const FormInputLayout: FC<FormInputLayoutProps> = ({
  label,
  name,
  helpElement,
  fieldElement,
}) => {
  return (
    <div className="form-input-container">
      <div className="form-input-field">
        <label className="form-input-field--label" htmlFor={name}>
          {label}
        </label>
        {fieldElement}
        {helpElement ? (
          <div className="form-input--help">{helpElement}</div>
        ) : null}
      </div>
    </div>
  );
};
